import axios from "axios";
import router from "./router";
import store from "./store";

axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject("request", error);
  }
);

axios.interceptors.response.use(
  (response) => {
    if (response.status && [403, 401].indexOf(response.status) > -1) {
      router.replace("/logout");
      store.set("token", null);
      return Promise.reject(response.data);
    } else {
      if (response.data && response.data.token) {
        //store.set("token", response.data.token);
      }
      return response.data;
    }
  },
  (error) => {
    if (error.response) {
      if (error.response.data && error.response.data.message) return Promise.reject(error.response.data.message);
      return Promise.reject(error.response);
    }
    return error;
  }
);

export default {
  post(url, params) {
    try {
      let headers = {};
      if (store.get("token"))
        headers = {
          headers: {
            Authorization: "Bearer " + store.get("token"),
          },
        };
      console.log("headers", headers);
      const res = axios.post(url, params, headers);
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(JSON.stringify(error));
    }
  },
  put(url, params) {
    try {
      let headers = {};
      if (store.get("token"))
        headers = {
          headers: {
            Authorization: "Bearer " + store.get("token"),
          },
        };

      const res = axios.put(url, params, headers);
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(JSON.stringify(error));
    }
  },
  get(url) {
    try {
      let headers = {};
      if (store.get("token"))
        headers = {
          headers: {
            Authorization: "Bearer " + store.get("token"),
          },
        };

      const res = axios.get(url, headers);
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(JSON.stringify(error));
    }
  },
  delete(url, id) {
    try {
      let headers = {};
      if (store.get("token")) {
        headers = {
          headers: {
            Authorization: "Bearer " + store.get("token"),
          },
          data: {
            id
          }
        }
      }

      const res = axios.delete(`${url}`, headers);
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(JSON.stringify(error));
    }
  },
};
